import Phaser from 'phaser';

export default class Preloader extends Phaser.Scene {
  constructor() {
    super('preloadScene');
  }
  // Preload assets here
  preload() {
    this.load.atlas(
      'player',
      './Assets/player.png',
      './Assets/player_atlas.json'
    );
    this.load.animation('playerAnim', './Assets/player_anim.json');
    this.load.tilemapTiledJSON('grassland', './Assets/map.json');
    this.load.image(
      'grassImage',
      './Assets/grassland_tileset/grassland_tileset/spritesheet/spritesheet.png'
    );
    this.load.image(
      'stone-05',
      './Assets/Stones Pack X10/Stones Pack X10/Rocks with plants/stone_5.png'
    );
    this.load.image('background', './Assets/map.png');
  }

  create() {
    this.scene.run('menuScene');
  }
}
